var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeW(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m317 213.963h-119c-26.536-1.056-26.516-38.953 0-40h119c26.536 1.056 26.516 38.953 0 40zm195 178v-168.271c0-37.19-17.654-72.86-47.227-95.415l-136-103.729c-42.848-32.681-102.699-32.681-145.547 0l-136 103.729c-29.572 22.555-47.226 58.224-47.226 95.415v168.271c0 66.168 53.832 120 120 120h22c27.57 0 50-22.43 50-50v-103c3.581-86.252 126.451-86.186 130 0v103c0 27.57 22.43 50 50 50h20c66.168 0 120-53.833 120-120zm-360-33v103c0 5.514-4.486 10-10 10h-22c-44.112 0-80-35.888-80-80v-168.271c0-24.794 11.77-48.573 31.484-63.61l136-103.729c28.564-21.787 68.467-21.787 97.031 0l136 103.729c19.715 15.036 31.485 38.816 31.485 63.61v168.271c0 44.112-35.888 80-80 80h-20c-5.514 0-10-4.486-10-10v-103c0-57.897-47.103-105-105-105s-105 47.102-105 105z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeW);
export default __webpack_public_path__ + "static/media/homeW.e5e5c9884b0d0c818bcb9bc331ce0608.svg";
export { ForwardRef as ReactComponent };